import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    englishName: data?.localized_data?.en?.name,
    arabicName: data?.localized_data?.ar?.name,
    englishDescription: data?.localized_data?.en?.description,
    arabicDescription: data?.localized_data?.ar?.description,
    image: data?.image_url,
  };
};

export const structure = (_, __, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: t("common.image"),
        width: "100%",
      },
      {
        name: `englishName`,
        kind: "input",
        type: "text",
        label: `${t("lookups_themes.name_en")}*`,
        width: "47%",
      },
      {
        name: `arabicName`,
        kind: "input",
        type: "text",
        label: `${t("lookups_themes.name_ar")}*`,
        width: "47%",
      },
      {
        name: `englishDescription`,
        kind: "input",
        type: "text",
        label: t("lookups_themes.description_en"),
        width: "100%",
      },
      {
        name: `arabicDescription`,
        kind: "input",
        type: "text",
        label: t("lookups_themes.description_ar"),
        width: "100%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    englishName: Yup.string().required("required"),
    arabicName: Yup.string().required("required"),
    englishDescription: Yup.string(),
    arabicDescription: Yup.string(),
  });
